module.exports = __webpack_public_path__ + "img/supernova.1e393676.jpg";